<div id="utf-syncing-information">
  <div class="row no-gutters">
      <div class="col-lg-4">
          <app-progress-tracker></app-progress-tracker>
      </div>
      <div class="col-lg-8" id="form-component-section">
          <app-utf-syncing-information-page></app-utf-syncing-information-page>
      </div>
  </div>
</div>